export class Tax {
    constructor(props) {
        Object.assign(this, props);
    }
}
export const TaxCategory = {
    Article: 'article',
    Customer: 'customer'
};
export const TaxType = {
    Percentaje: 'percentaje',
    Map: 'map'
};
export class TaxMap {
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/Model.ts
// module id = 56
// module chunks = 0